module.exports = "<app-navbar></app-navbar>\n<div class=\"container-fluid\" style=\"margin-top: .5em;\">\n  <router-outlet></router-outlet>\n</div>\n"